<template>
  <div>
    <AppBar />
    <v-row>
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Today
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar && !isMobile">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="pageDiv">
            <v-btn @click="goBack()" color="primary" v-if="$store.state.calendar && !isMobile">
              {{ $store.state.calendar.name }}
            </v-btn>
            <v-btn plain disabled v-if="!$store.state.calendar && !isMobile">
              {{ $store.state.name ? $store.state.name : 'My page' }}
            </v-btn>
            </div>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{
                    isMobile ? typeToLabelMobile[typeMobile] : typeToLabel[type]
                  }}</span>
                  <v-icon right> mdi-menu-down </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="(type = 'day'), (typeMobile = 'day')">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!isMobile" @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="(type = 'month'), (typeMobile = 'month')">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="(type = '4day'), (typeMobile = '4day')">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <div class="text-center" v-if="isMobile">
          <v-btn color="primary" @click="goBack()" v-if="$store.state.calendar && isMobile">
            {{ $store.state.calendar.name }}
          </v-btn>
          <v-btn plain disabled v-if="!$store.state.calendar && isMobile">
              {{ $store.state.name ? $store.state.name : 'My page' }}
          </v-btn>
          <br v-if="isMobile" />
          <span v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </span>
        </div>
        <v-sheet>
          <v-calendar
            ref="calendar"
            v-model="focus"
            :start="startDate"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="isMobile ? typeMobile : type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange, getEvents"
            @mousedown:event="startDrag"
            @mousedown:time="startTime"
            @mousemove:time="mouseMove"
            @mouseup:time="endDrag"
            @mouseleave.native="cancelDrag"
            @touchstart:event="startDrag"
            @touchstart:time="oneClick"
            @touchmove:time="mouseMove"
            @touchend:time="endDrag"
            @touchleave.native="cancelDrag"
          >
            <template v-slot:day-body="{ date, week }">
              <div
                class="v-current-time"
                :class="{ first: date === week[0].date }"
                :style="{ top: nowY }"
              ></div> </template
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-btn icon v-if="editAccess()" @click="dataEdit()">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu v-if="editAccess()" bottom offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>mdi-list-status</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in statusList"
                      :key="index"
                      @click="setStatus(item)"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-card-text>
                <span v-html="selectedEvent.details"></span>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-card-text class="text-right">
                  <span v-html="'From: ' + selectedEvent.fromname"></span>
                </v-card-text>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
      <v-dialog v-model="enterDialog" persistent max-width="600px">
        <v-form ref="form" v-model="taskFormValid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{
                isEdit ? "Edit Task" : "Add New Task"
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      label="Title*"
                      maxlength="32"
                      v-model="enterDataDialog.name"
                      :rules="titleRules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="enterDataDialog.date"
                      label="Date"
                      prepend-icon="mdi-calendar"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Discription*"
                      v-model="enterDataDialog.details"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      label="Assign To*"
                      :items="getFriends"
                      :disabled="isEdit"
                      v-model="enterDataDialog.assignTo"
                      :rules="assingRules"
                      required
                      multiple
                      item-text="text"
                      item-value="value"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="removeAssign(data.item)"
                          >{{ data.item.text }}</v-chip
                        ></template
                      ></v-autocomplete
                    >
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="enterDataDialog.allDay"
                      label="All day"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="enterDataDialog.isPrivate"
                      label="Private"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="enterDataDialog.isImportant"
                      label="Important"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="!enterDataDialog.allDay">
                    <v-dialog
                      ref="dialogStart"
                      v-model="timeStartDialog"
                      :return-value.sync="timeStart"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formattedTimeStart"
                          label="Start Time"
                          prepend-icon="mdi-clock-time-four-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="timeStart"
                        format="ampm"
                        :min="startTimeCal"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="timeStartDialog = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialogStart.save(timeStart)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="!enterDataDialog.allDay">
                    <v-dialog
                      ref="dialogEnd"
                      v-model="timeEndDialog"
                      :return-value.sync="timeEnd"
                      :min="timeStart"
                      required
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formattedTimeEnd"
                          label="End Time"
                          prepend-icon="mdi-clock-time-four-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="timeEnd"
                        :min="timeStart"
                        format="ampm"
                        full-width
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="timeEndDialog = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialogEnd.save(timeEnd)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="saveData(false)">
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                :disabled="!taskFormValid"
                @click="validate()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
const moment = require("moment");
import api from "../api";
import AppBar from "../components/AppBar";

export default {
  components: {
    AppBar,
  },
  data: () => ({
    focus: "",
    type: "week",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    typeMobile: "day",
    typeToLabelMobile: {
      month: "Month",
      day: "Day",
      "4day": "4 Days",
    },
    statusList: [
      { title: "Complete", value: "Confirm", icon: "mdi-check" },
      { title: "Decline", value: "Decline", icon: "mdi-cancel" },
      { title: "Redirect", value: "Redirect", icon: "mdi-swap-horizontal" },
    ],
    titleRules: [
      (v) => !!v || "Title is required",
      (v) => (v && v.length <= 32) || "Title must be less than 32 characters",
    ],
    assingRules: [(v) => (v && v.length > 0) || "Assign is required"],
    isEdit: false,
    taskFormValid: false,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    startDate: moment().toDate(),
    ready: false,
    events: [],
    delay: 700,
    clicks: 0,
    enterDialog: false,
    timeStartDialog: false,
    timeEndDialog: false,
    datePickerDialog: false,
    date: null,
    timeStart: null,
    timeEnd: null,
    lastCreatedEvent: null,
    enterDataDialog: {
      name: "New task",
      details: "",
      date: null,
      start: null,
      end: null,
      isPrivate: false,
      allDay: false,
      assignTo: null,
      isImportant: false,
    },
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 676;
    },
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + "px" : "-10px";
    },
    getId() {
      return this.$store.state.uid;
    },
    getFriends() {
      let tmp = this.$store.state.data.friends.map((el) => {
        return { text: el.name, value: el.uid };
      });
      tmp.unshift({ text: "Me", value: this.getId });
      return tmp;
    },
    formattedTimeStart() {
      return this.timeStart
        ? moment(this.timeStart, "HH:mm").format("hh:mm A")
        : "";
    },
    formattedTimeEnd() {
      return this.timeEnd
        ? moment(this.timeEnd, "HH:mm").format("hh:mm A")
        : "";
    },
    getEvents() {
      return this.$store.state.data.events;
    },
    startTimeCal() {
      if (!this.cal) return null;
      if (this.date !== this.cal.times.now.date) return null;
      return this.cal.times.now.time;
    },
  },
  mounted() {
    this.checkLogin()
  },
  watch: {
    getEvents: function (newData) {
      var me = this;
      if (this.$store.state.isUpdate) {
        this.events = [];
        this.$store.state.isUpdate = false;
      }
      newData.forEach(function (el) {
        let find = false;
        me.events.forEach(function (event) {
          if (JSON.stringify(event) === JSON.stringify(el)) {
            find = true;
            return;
          }
          if (event.id == el.id) {
            Object.assign(event, el);
            find = true;
          }
        });
        if (!find) {
          me.events.push(el);
        }
      });
    },
  },
  methods: {
    // intervalStyle(int) {
    //   return int.past ? {backgroundColor: "#f7f7f7"} : null
    // },
    checkLogin() {
      var me = this;
      api.checkLogin(me, function(success) {
        if (success) {
          me.checkNotificationPromise()
          me.ready = true;
          me.scrollToTime();
          me.updateTime();
        }
      })
    },
    checkNotificationPromise() {
      try {
        Notification.requestPermission().then();
      } catch(e) {
        return false;
      }
      return true;
    },
    oneClick(event) {
      this.clicks++;
      if (this.clicks === 1) {
        this.timer = setTimeout(() => {
          this.clicks = 0;
        }, this.delay);
      } else {
        this.startTime(event)
        clearTimeout(this.timer);
        this.clicks = 0;
      }
    },
    goBack() {
      this.$store.state.calendar = null;
      this.$store.state.isUpdate = true;
      this.$store.dispatch("updateData");
    },
    removeAssign(item) {
      const index = this.enterDataDialog.assignTo.indexOf(item.value);
      if (index >= 0) this.enterDataDialog.assignTo.splice(index, 1);
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
      this.typeMobile = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    startDrag({ event, timed }) {
      if (event && timed) {
        if (!this.enableDrag(event)) return
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null;
      }
    },
    startTime(tms) {
      const mouse = this.toTime(tms);
      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start;
        this.dragEvent.lastStart = start;
        this.dragTime = mouse - start;
      } else {
        if (tms.past == true || tms.present == true) {
          return;
        }
        this.createStart = this.roundTime(mouse);
        this.createEvent = {
          name: "New task",
          color: "light-blue lighten-1",
          start: this.createStart,
          end: this.createStart,
          timed: true,
          isPrivate: false,
          allDay: false,
          isImportant: false,
          day: tms.day,
          date: tms.date,
        };
        this.events.push(this.createEvent);
      }
    },
    extendBottom(event) {
      this.createEvent = event;
      this.createStart = event.start;
      this.extendOriginal = event.end;
    },
    mouseMove(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start;
        const end = this.dragEvent.end;
        const duration = end - start;
        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;
        if (newStart < this.toTime(this.cal.times.now)) return;
        this.dragEvent.start = newStart;
        this.dragEvent.end = newEnd;
      } else if (this.createEvent && this.createStart !== null) {
        if (tms.past == true || this.createEvent.day != tms.day) return;
        const mouseRounded = this.roundTime(mouse, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.start = min;
        this.createEvent.end = max;
      }
    },
    endDrag() {
      if (this.createEvent && this.createStart !== null) {
        this.lastCreatedEvent = this.createEvent;
        this.dragTime = null;
        this.dragEvent = null;
        this.createEvent = null;
        this.createStart = null;
        this.extendOriginal = null;
        this.dataEnter(this.lastCreatedEvent);
      } else if (this.dragEvent && this.dragTime !== null) {
        this.updateTimeEvent(this.dragEvent);
        this.dragTime = null;
        this.dragEvent = null;
        this.createEvent = null;
        this.createStart = null;
        this.extendOriginal = null;
      }
    },
    cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal;
        } else {
          const i = this.events.indexOf(this.createEvent);
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      this.createEvent = null;
      this.createStart = null;
      this.dragTime = null;
      this.dragEvent = null;
    },
    roundTime(time, down = true) {
      const roundTo = 5; // minutes
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
    rndElement(arr) {
      return arr[this.rnd(0, arr.length - 1)];
    },
    dataEnter(event) {
      this.timeStart = moment(event.start).format("HH:mm");
      this.timeEnd = moment(event.end).format("HH:mm");
      this.enterDataDialog.date = event.date;
      this.enterDataDialog.allDay = false;
      this.enterDataDialog.isPrivate = false;
      this.enterDataDialog.isImportant = false;
      this.enterDataDialog.assignTo = [
        this.$store.state.calendar ? this.$store.state.calendar.id : this.getId,
      ];
      this.isEdit = false;
      this.enterDialog = true;
    },
    dataEdit() {
      this.date = this.selectedEvent.date;
      this.enterDataDialog = this.selectedEvent;
      this.enterDataDialog.isPrivate = this.selectedEvent.type === "private";
      this.enterDataDialog.isImportant = this.selectedEvent.important;
      this.timeStart = moment(this.selectedEvent.start).format("HH:mm");
      this.timeEnd = moment(this.selectedEvent.end).format("HH:mm");
      this.isEdit = true;
      this.enterDialog = true;
    },
    editAccess() {
      return this.$store.state.uid == this.selectedEvent.fromId || this.$store.state.uid == this.selectedEvent.toId
    },
    enableDrag(event) {
      return this.$store.state.uid == event.fromId || this.$store.state.uid == event.toId
    },
    saveData(isSave) {
      const i = this.events.indexOf(this.lastCreatedEvent);
      if (!isSave) {
        if (i !== -1) {
          this.events.splice(i, 1);
        }
      } else {
        var date = moment(this.lastCreatedEvent.start).format("YYYY-MM-DD");
        this.enterDataDialog.date = date;
        this.enterDataDialog.start = moment(
          date + " " + this.timeStart
        ).valueOf();
        this.enterDataDialog.end = moment(date + " " + this.timeEnd).valueOf();
        this.enterDataDialog.timed = !this.enterDataDialog.allDay;
        api.addTask(this.enterDataDialog, this);
        this.$store.dispatch("updateData");
        this.events.splice(i, 1);
      }
      this.enterDialog = false;
      this.enterDataDialog = {
        name: "New task",
        details: "",
        date: null,
        start: null,
        end: null,
        isPrivate: false,
        allDay: false,
        assignTo: null,
        isImportant: false,
      };
    },
    editData() {
      var date = moment(this.selectedEvent.start).format("YYYY-MM-DD");
      this.enterDataDialog.date = date;
      this.enterDataDialog.start = moment(
        date + " " + this.timeStart
      ).valueOf();
      this.enterDataDialog.end = moment(date + " " + this.timeEnd).valueOf();
      this.enterDataDialog.timed = !this.enterDataDialog.allDay;
      api.editTask(this.enterDataDialog, this);
      this.$store.dispatch("updateData");
      this.enterDialog = false;
      this.enterDataDialog = {
        name: "New task",
        details: "",
        date: null,
        start: null,
        end: null,
        isPrivate: false,
        allDay: false,
        assignTo: null,
        isImportant: false,
      };
    },
    validate() {
      this.$refs.form.validate();
      let timeCheck = true;
      let timeStart = moment(this.enterDataDialog.date + " " + this.timeStart);
      let timeEnd = moment(this.enterDataDialog.date + " " + this.timeEnd);
      let timeNow = moment(
        this.cal.times.now.date + " " + this.cal.times.now.time
      );
      if (
        !this.isEdit &&
        (moment(timeStart).isBefore(timeNow) ||
          moment(timeStart).isAfter(timeEnd))
      ) {
        timeCheck = false;
      }
      if (
        this.isEdit &&
        (moment(timeStart).isBefore(timeNow) ||
          moment(timeStart).isAfter(timeEnd))
      ) {
        if (
          !moment(this.selectedEvent.start).isSame(timeStart) ||
          !moment(this.selectedEvent.end).isSame(timeEnd)
        ) {
          timeCheck = false;
        }
      }
      if (!timeCheck) {
        return this.$notify({
          group: "notify",
          type: "error",
          title: "Error",
          text: "Incorrect time",
          duration: 3000,
        });
      }
      if (this.taskFormValid && timeCheck && !this.isEdit) {
        this.saveData(true);
      }
      if (this.taskFormValid && timeCheck && this.isEdit) {
        this.editData();
      }
    },
    setStatus(item) {
      api.setStatus(this.selectedEvent.id, item.value, this);
    },
    updateTimeEvent(event) {
      if (event.lastStart == event.start) return;
      event.date = moment(event.start).format("YYYY-MM-DD");
      api.updateTimeEvent(event, this);
    },
  },
};
</script>

<style lang="scss">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
.v-past {
  background-color: #f1f1f1;
}
.v-chip {
  background-color: #f1f1f1;
}
.pageDiv {
  position: absolute;
  left: 47%;
}
.theme--light.v-calendar-events .v-event-timed.rborder {
  border-color: #df0000dc !important;
}
.theme--dark.v-calendar-events .v-event-timed.rborder {
  border-color: #df0000dc !important;
}

.v-btn--disabled .v-btn__content {
  opacity: 1 !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>